import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { alertsDataAutomation } from "app/pages/activation/components/HomeWithData/dataAutomationKeys";

import * as SC from "./styles";

export const LoadingItem = () => (
    <SC.Container
        $isLoading
        data-automation={alertsDataAutomation.loadingItem}
    >
        <SC.IconLoader
            height={32}
            width={32}
        />

        <SC.ContentContainer>
            <PixelPlaceholderLoader
                height={12}
                width={132}
            />
            <PixelPlaceholderLoader
                height={10}
                width={460}
            />
            <PixelPlaceholderLoader
                height={10}
                width={290}
            />
        </SC.ContentContainer>
    </SC.Container>
);
